import { useCallback, useState } from 'react';

/**
 * A counter that a data-loading effect can depend on, plus the function that
 * bumps it.
 *
 * Pages fetch inside a `useEffect`; retrying means running that effect again.
 * Adding `retryKey` to its dependency list and calling `retry()` from the
 * error view is the smallest way to do that without lifting every fetch out
 * into a callback (F30).
 */
export function useRetry(): { retryKey: number; retry: () => void } {
    const [retryKey, setRetryKey] = useState(0);
    const retry = useCallback(() => setRetryKey(key => key + 1), []);
    return { retryKey, retry };
}

export default useRetry;
